import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchLanguages(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/contract_template_language/list', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    fetchLanguage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`/contract_template_language/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    },
    addLanguage(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/contract_template_language', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    deleteLanguage(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/contract_template_language', {params:data})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
    

  },
}
